import type { ComponentTemplate } from "schemas/generated/componentTemplates";

export const h2: ComponentTemplate = {
  id: "cbb42361-c053-467b-87f5-82d54be78a19",
  storeId: null,

  scope: "left-bar",
  type: "component",
  name: "Basic/h2",
  leftBarCategory: { main: "basic", subCategory: "text" },
  preview: "basic/h2.svg",
  tags: ["heading", "text", "subtitle"],
  transforms: [],
  template: {
    id: "$uid",
    type: "text",
    props: {
      text: "<h2>Add new heading here</h2>",
      style: {
        fontSize: "32px",
        lineHeight: "36px",
      },
    },
  },
};
